import { Navigate } from "react-router-dom";
import { ExternalContainer } from "../../components/Account/reusables";
import { useAppSelector } from "../../hooks/hooks";
import CartItems from "./CartItems";
import Checkout from "./Checkout";
import { EmptyCartState } from "./EmptyCart";
import { getActiveUserId } from "./utils";
import { selectUserCartItems } from "../../features/store/cartSlice";
import { RootState } from "../../redux/store";

const Cart = () => {
  const { user } = useAppSelector((state) => state.auth);

  const userId = getActiveUserId(user);

  const length = useAppSelector(
    (state: RootState) => selectUserCartItems(state, userId).length,
  );

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="h-full w-full px-4 sm:px-6 lg:px-8 xl:px-12 max-w-[1440px] mx-auto">
      <ExternalContainer>
        {length === 0 ? (
          <div className="py-12 sm:py-20 flex items-center justify-center min-h-[50vh]">
            <EmptyCartState />
          </div>
        ) : (
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 xl:gap-16 items-start py-6 sm:py-10">
            <div className="w-full lg:w-[58%] xl:w-[56%]">
              <CartItems userId={userId} />
            </div>
            <div className="w-full lg:w-[42%] xl:w-[44%] lg:sticky lg:top-6">
              <Checkout userId={userId} />
            </div>
          </div>
        )}
      </ExternalContainer>
    </div>
  );
};

export default Cart;
